import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn } from '@angular/router';
import { Store } from '@ngxs/store';
import { DisabledAccountRedirectService } from '@platform-frontend/account';
import { AcademicRegistration, FlowStartupService, RefreshAcademicRegistrationMessageParams, SetAcademicUserType, UserType } from '@platform-frontend/checkout';
import { InvalidStateError, SimpleRouterState } from '@platform-frontend/util';
import { Buffer } from 'buffer';
import { Observable, throwError } from 'rxjs';
import { switchMap } from 'rxjs/operators';

export const AcademicRegistrationStartupGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const store = inject(Store);
  const flowStartupService = inject(FlowStartupService);
  const disabledAccountRedirectService = inject(DisabledAccountRedirectService);

  if (store.selectSnapshot(SimpleRouterState.guardsActivated)) {
    const startParamsBase64 = route.paramMap.get('startParams');
    if (!startParamsBase64) {
      return throwError(() => new InvalidStateError('No startParams provided'));
    }

    const startParams = JSON.parse(Buffer.from(startParamsBase64, 'base64').toString()) as RefreshAcademicRegistrationMessageParams;
    const flow: AcademicRegistration = { type: 'ACADEMIC_REGISTRATION', startParams };

    flowStartupService
      .getStartupObservable(flow, () => preventStartFlow(disabledAccountRedirectService, store, flow.startParams.start?.type ?? null))
      .subscribe();
  }
  return true;
};

const preventStartFlow: (disabledAccountRedirectService: DisabledAccountRedirectService, store: Store, userType: UserType | null) => Observable<boolean> = (
  disabledAccountRedirectService: DisabledAccountRedirectService,
  store: Store,
  userType: UserType | null
) => {
  if (userType === null) {
    return disabledAccountRedirectService.redirectDisabledUser(true);
  } else {
    return store.dispatch(new SetAcademicUserType(userType)).pipe(switchMap(() => disabledAccountRedirectService.redirectDisabledUser(true)));
  }
};
